import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Button, Paper, Container } from "@mui/material";
import { Home as HomeIcon, Celebration as CelebrationIcon } from "@mui/icons-material";

// Helper function to check dashboard access based on roles
const checkDashboardAccess = (roles) => {
  if (!roles || !Array.isArray(roles)) return false;
  
  const dashboardRoles = [
    'ROLE_ADMIN',
    'ROLE_WALIDATA',
    'ROLE_WALIDATA_PENDUKUNG',
    'ROLE_PRODUSEN'
  ];
  
  return roles.some(role => dashboardRoles.includes(role));
};

// Welcome Component for users without dashboard access
const WelcomeMessage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 2
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 3
          }}
        >
          <CelebrationIcon 
            sx={{ 
              fontSize: 80, 
              color: 'primary.main',
              mb: 2 
            }} 
          />
          <Typography variant="h4" gutterBottom fontWeight="bold" color="text.primary">
            Selamat Datang di SIBATNAS!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Sistem Informasi Batimetri Nasional menyediakan data batimetri dan DEM 
            untuk keperluan riset, pembangunan, dan perencanaan wilayah Indonesia.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Silakan kembali ke beranda untuk mengakses peta dan mengunduh data.
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            href="/"
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Kembali ke Beranda
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

const LoggedArea = ({ children }) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const location = useLocation();

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/auth/login" />;
  }

  // Check if user can access dashboard
  const canAccessDashboard = checkDashboardAccess(currentUser?.roles);

  // If user cannot access dashboard, show welcome message
  if (!canAccessDashboard) {
    return <WelcomeMessage />;
  }

  return children;
};

export default LoggedArea;
